(function () {
    'use strict';
    var controllerId = 'cndAccredSettoreAdd';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', '$uibModalInstance', 'cndAccredSettore', 'cndAccreditamentoId', 'progettoId', 'settori', cndAccredSettoreAdd]);

    function cndAccredSettoreAdd($scope, datacontext, $uibModalInstance, cndAccredSettore, cndAccreditamentoId, progettoId, settori) {
        $scope.settori = settori;

        if (cndAccredSettore) {
            $scope.title = 'Modifica Settore';
            $scope.record = jQuery.extend({}, cndAccredSettore); //Clona oggetto
        }
        else {
            $scope.title = 'Nuovo Settore';
            $scope.record = {};
            $scope.record.Id = 0;
        }

        if (progettoId) {
            $scope.progettoId = progettoId;
        }


        if (cndAccreditamentoId) {
            $scope.cndAccreditamentoId = cndAccreditamentoId;
            $scope.record.CNDAccreditamentoId = cndAccreditamentoId;
        }

        $scope.ok = function (isValid) {
            if (isValid) {
                if ($scope.record.Id == 0) {
                    var result = addItem($scope.record);
                    $uibModalInstance.close(result);
                }
                else {
                    var result2 = updateItem($scope.record);
                    $uibModalInstance.close(result2);
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.cndAccreditamentoSettore_add(item).then(function (data) {
                return data;
            });
        }

        function updateItem(item) {
            return datacontext.cndAccreditamentoSettore_update(item).then(function (data) {
                return data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID CODICE FISCALE -#-#-#-#-#-#
        $scope.bExist = false;
        $scope.exists = function (value) {
            console.log('exists()');
            $scope.bExist = true;
            return datacontext.cndAccreditamentoSettore_exists($scope.progettoId, $scope.record.CNDAccreditamentoId, value, $scope.record.Id).then(function (data) {
                return $scope.bExist = data;
            });
        };

    }
})();